import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import PromoBanner from '../Components/PromoBanner';
import Navbar from '../Components/Navbar';
import Products from '../Components/Products';
import Sample from '../Components/Sample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import add from '../Images/add-square.png';
import collectionBackgroundImage from '../Images/Untitled-1.png';
import TrophyIcon from '../Images/cup.svg';
import TruckIcon from '../Images/car.svg';
import TagIcon from '../Images/wallet.png';
import { useNavigate } from 'react-router-dom';


const ProductCard = ({ product }) => {

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = () => {
    navigate('/product', {
      state: { 
        scrollToPromo: true,
        productId: product.id,  // Pass the product.id here
      },
    });
  };

  

  return (
    <div className="flex flex-col items-start bg-white rounded-lg shadow-lg mx-2 my-2 cursor-pointer" onClick={handleClick}>
      <div className="w-full">
        <img src={product.default_image} alt={product.name} className="w-full h-auto object-cover mb-4" />
      </div>
      <div className="text-start pl-5">
        <h3 className="text-md mb-2" style={{ fontFamily: 'arial' }}>{product.name}</h3>
        <p className="text-xs mr-2 mb-7" style={{ fontFamily: 'arial', color: '#8C8C8C' }}>
  {product.brief.length > 150
    ? `${product.brief.slice(0, 150)}...`
    : product.brief}
</p>
        <div className="flex flex-row items-center justify-between mb-5 gap-10">
          <p className=" " style={{ fontFamily: 'arial', fontSize:'13px' }}>{`From £${product.start_price}`}</p>
          <div className="flex flex-row items-center gap-2">
            <p className="" style={{ color: '#EC008C', fontFamily: 'arial', fontSize:'13px' }}>
              Shop Now
            </p>
            <button>
              <img src={add} className="w-4 h-4 mr-2" alt="Add" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CategoryName = () => {
  const location = useLocation();
  const promoBannerRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [noActive, setNoActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { categoryId, categoryName, description, banner } = location.state || {};
console.log('categoryId', categoryId)
console.log('categoryName', categoryName)
console.log('description', description)
console.log('banner', banner)

useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  useEffect(() => {
    if (!categoryId) return;
    setIsLoading(true);
    axios
      .post('https://backend.printtrio.co.uk/api/product/get-products', { categoryId })
      .then(response => {
        if (response.data.success) {
          // 1️⃣ Filter only active products
          const active = response.data.data.filter(p => p.is_active === 1);

          if (active.length > 0) {
            setProducts(active);
            setNoActive(false);
          } else {
            // 2️⃣ No active products at all
            setProducts([]);
            setNoActive(true);
          }
        } else {
          // handle a “success: false” response if you need to
          setProducts([]);
          setNoActive(true);
        }
      })
      .catch(err => {
        console.error('Error fetching the products:', err);
        setProducts([]);
        setNoActive(true);
      })
      .finally(() => {
        setIsLoading(false); // Always turn off loading spinner
      });
  }, [categoryId]);

  const SliderAllCategories = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
      (
        <div className="px-6 flex flex-col md:flex-row justify-between items-center "
        style={{
          backgroundImage: `url(${banner})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            aspectRatio: '16 / 6',
        }}
    >
          <div className="flex-1  mr-40 md:mr-0 mt-10">
                    <h1 className="text-white font-bold ttext-xl md:text-4xl xl:text-6xl leading-tight mb-4 px-0 xl:px-20  ">
            {categoryName}
            </h1>
            <p className="text-white text-xs md:text-base  mb-6 px-0 xl:px-20 max-w-2xl">
              {description} 
            </p>
          </div>
        </div>
      ),
    ];

    return (
      <div>
        <div className="w-full h-full flex flex-col justify-center px-0 xl:px-0 max-w-screen-xl mx-auto  relative">
          {slides[currentSlide]}
          <div className="flex items-center justify-end space-x-2">
            {slides.map((_, index) => (
              <span key={index}
                style={{
                  width: currentSlide === index ? '20px' : '8px',
                  backgroundColor: currentSlide === index ? '#ec008c' : 'white',
                  opacity: currentSlide === index ? '2' : '0.5',
                }}
              ></span>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center px-20 md:px-16 xl:px-48 space-y-12 md:space-y-0 bg-white py-8 md:py-8 max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
          <div className="flex flex-row items-center gap-4 pl-0 md:pl-1">
            <img src={TrophyIcon} alt="Premium Quality" className="h-8 w-8" />
            <p className="text-black text-xs xl:text-xl mt-2">Premium Quality Made In The UK</p>
          </div>
          <div className="flex flex-row items-center gap-4">
            <img src={TruckIcon} alt="Fast Delivery" className="h-8 w-8" />
            <p className="text-black text-xs xl:text-xl mt-2">Fast Production And Delivery</p>
          </div>
          <div className="flex flex-row items-center gap-4">
            <img src={TagIcon} alt="Low Price" className="h-8 w-8" />
            <p className="text-black text-xs xl:text-xl mt-2">Low Price And Low Quantity Orders</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div ref={promoBannerRef}>
        <PromoBanner />
      </div>
      <Navbar />
    {isLoading ? (
      <div className="flex justify-center items-center h-screen">
        {/* simple Tailwind spinner */}
        <svg
          className="animate-spin h-12 w-12 text-pink-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    ) : (
      <>
      <SliderAllCategories />
      <div className="flex flex-col bg-gray-100 py-12 px-2 md:px-16 xl:px-48 max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
        <h1 className="text-4xl font-semibold my-6 text-center" style={{ fontFamily: 'arial' }}>{categoryName}</h1>
        <div className="relative mt-10">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
            {products.map((product) => (
              <div key={product.id}>
                <ProductCard product={product} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Products />
      <Sample />
      <Subscribe />
      <FixedImageMessage />
      <Footer />
      </>
       )}
    </div>
  );
};

export default CategoryName;
